import React from 'react';
import { Route, Switch } from 'react-router-dom';

import TransporterClientScreen from './Components/TransporterClientScreen'


const RouterOutlet = () => {
  return (
    <Switch>
      <Route path="/" component={TransporterClientScreen} exact/>
      <Route path="/profile" component={TransporterClientScreen} exact/>
      <Route path="/profile/:name" component={TransporterClientScreen} exact/>
     
    </Switch>
  );
};

export default RouterOutlet;
